import router from "./router";
// import VueCookies from "vue-cookies";
import store from "./store";
import { Message } from "element-ui";
import {
  setCookie,
  getCookie,
  removeCookie,
  delCookieInfos
} from "@/utils/util.js";

// VueCookies.remove("routerGo");
removeCookie("routerGo");

// console.log("VueCookiesxx", VueCookies);
router.beforeEach(async (to, from, next) => {
  // var userToken = VueCookies.get("userToken");
  // var userId = VueCookies.get("Role-Id");

  var userToken = getCookie("userToken");
  var userId = getCookie("Role-Id");

  // 测试1
  // console.log("userTokenxxx ", userToken, userToken == null, userToken == "");

  if (userToken) {
    try {
      next();
      // var routerGo = VueCookies.get("routerGo");
      var routerGo = getCookie("routerGo");
      // console.log("routerGo", routerGo, routerGo == null);
      if (routerGo == null) {
        const accessRoutes = await store.dispatch("GenerateRoutes");
        router.addRoutes(accessRoutes); // 动态添加可访问路由表
        console.log(accessRoutes, "accessRoutes");
      }
      if (userId) {
        // VueCookies.set("routerGo", 1);
        setCookie("routerGo", 1);
      }
    } catch (error) {
      // console.log(error, "errorerrorerror");
      // VueCookies.set("userToken", null);
      // setCookie("userToken", null);
      // 这里应该将所有的参数全部清除更合适
      removeCookie("userToken");
      delCookieInfos();
      // this.$message.error('内部错误,请重新登录!');
      Message.error("内部错误,请重新登录!");
      // Message({
      //   message: "内部错误,请重新登录!",
      //   type: "error",
      //   duration: 1000
      // });
      window.location.href = process.env.LOGINIURL;
    }
  } else {
    // VueCookies.set("userToken", null);
    // setCookie("userToken", null);
    removeCookie("userToken");
    delCookieInfos();
    // this.$message.error('token失效,请重新登录!');
    Message.error("token失效,请重新登录!");
    window.location.href = process.env.LOGINIURL;
  }
});



// WEBPACK FOOTER //
// ./src/promission.js